import { EMkStepStatus, MkApiContext, TMkStep } from '@typescript'
import { TMkResort } from '@features/search/services/searchTypes' // [WANRING] THIS IS NOT ALLOWED, THIS TYPE SHOULD BE MOVED
import { IMkAnyBookField, IMkBookState, IMkBookTimerData, IMkTripSummary, MkModifyBookStep, TMkAvailableSuite } from '../../types'

export abstract class IBookService {
  static initialState?(): IMkBookState

  static checkStepStatus(step: TMkStep, status: EMkStepStatus): boolean {
    return [status, status?.toString()].includes(step.status)
  }

  static getReservationPointsDeficit(): number {
    return 10000 // todo: implement this as cost of reservation - available balance
  }

  abstract findStepIndexByName(stepName: string): number
  abstract getBookingTimerData(): IMkBookTimerData | undefined
  abstract getContextProps<T>(): T
  abstract getActiveStep(): TMkStep | undefined
  abstract getCreditsDeficit(userCreditsBalance?: number): number
  abstract getPointsDeficit(userPointsBalance?: number): number
  abstract getReservationPointsDeficit(): number
  abstract getStayCreditsCost(): number
  abstract getStayPointsCost(): number
  abstract handleStepComplete(): Promise<void>
  abstract handleStepEdit(step: TMkStep): void
  abstract handleStepInputFieldChange(step: TMkStep, fieldName: string, fieldValue: IMkAnyBookField['value'], fieldType: string, opts?: { checked?: boolean }): Promise<void>
  abstract initBooking(params: { resort: TMkResort; suite: TMkAvailableSuite; checkInDate: string; checkOutDate: string; vgerResortAvail?: any }): () => Promise<void>
  abstract initBookingTimer(durationMinutes: number, startTime?: number): void
  abstract stopBookingTimer(): void
  abstract clearBookingTimer(): void
  abstract setBookingError({ raw, message }: { raw?: Error; message?: string }): void
  abstract updatePointSliderValues(totalAmount: number, leadingValue: number, input1: IMkAnyBookField, input2: IMkAnyBookField): void
  abstract updateBookingTimer(remainingSeconds: number, isLastTwoMinutes: boolean, isTimeUp: boolean): void
  abstract initModification(params: { tripId: string; context?: MkApiContext | undefined; step?: MkModifyBookStep }): Promise<void>
  abstract cancelModification(): void
  abstract cancelBooking(): Promise<void>
  abstract getOriginalTripSummary(): IMkTripSummary | undefined
  abstract isInModificationMode(): boolean
  abstract applyModifications(): Promise<void>
  abstract setApiContext(context: MkApiContext): void
  abstract getApiContext(): MkApiContext
  abstract setRequiresAdditionalPayment(requiresAdditionalPayment: boolean): void
  abstract updateDatesStepContent(dates: { earliestCheckIn?: string; latestCheckOut?: string; excluded?: string[] }): void
  abstract updateBookDraft(bookDraft: IMkBookState['bookDraft']): void
}
